import React from "react";
import PropTypes from "prop-types";
import Tooltip from "../../utils/Tooltip";

const CheckboxWithTooltip = ({
  id,
  name,
  label,
  checked,
  value,
  onChange,
  helpId,
  tooltipInfo,
  disabled,
  children,
  contentStyle ={}
}) => {
  return (
    <div className="row">
      <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <div className="custom-control custom-checkbox">
          <input
            type="checkbox"
            className="custom-control-input asCompatible"
            data-help-id={helpId}
            name={name}
            id={id}
            value={value}
            checked={checked}
            onChange={onChange}
            disabled={disabled}   
          />
          <label
            className="custom-control-label line-height-25"
            htmlFor={id}
          >
            {label}
          </label>

       { tooltipInfo &&  <Tooltip
            position="right"
            iconColor="secondary"
            iconSize="small"
            information={tooltipInfo}
            contentStyle ={contentStyle}
          />}
        </div>
        {children}
      </div>
    </div>
  );
};

CheckboxWithTooltip.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string,
    PropTypes.number
  ]),
  onChange: PropTypes.func.isRequired,
  helpId: PropTypes.string,
  tooltipInfo: PropTypes.any,
  disabled: PropTypes.bool,
  children: PropTypes.node
};

CheckboxWithTooltip.defaultProps = {
  disabled: false
};

export default CheckboxWithTooltip;
